// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Validador automático de traducciones: detecta claves presentes en base que faltan en target.
 * @file frontend/src/i18n/validateTranslations.js
 * @description Compara objeto base (ej. en) con target (ej. es) y reporta keys faltantes.
 */

/**
 * Comprueba que todas las claves del objeto base existan en target.
 * Los objetos de traducción del proyecto son planos (claves tipo 'billing.usage.title').
 *
 * @param {Object} base - Objeto de referencia (ej. traducciones en)
 * @param {Object} [target] - Objeto a validar (ej. traducciones es)
 * @returns {string[]} Lista de claves faltantes en target
 */
export function validateTranslations(base, target) {
  const missing = [];

  if (!base || typeof base !== 'object') {
    return missing;
  }

  for (const key of Object.keys(base)) {
    if (!target || !Object.prototype.hasOwnProperty.call(target, key)) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    console.warn('[I18N] Missing keys in target:', missing);
  }
  return missing;
}

export default validateTranslations;
